import { getUser, useUser } from '@fs/zion-user'
import { useFeatureFlag } from '@fs/zion-flags'
import { splunk } from '@fs/zion-splunk-logger'
import { useQuery } from '@tanstack/react-query'
import { useAppProvider } from '../providers/AppProvider'
import axios from '../utils/giveAxios'

export default function useIsInmate() {
  const { signedIn, userLoading } = useUser()
  const { correctionalFacilityId } = useAppProvider()
  const enabled = signedIn && !userLoading
  const inmateLoggingFlag = useFeatureFlag('give_corrections_logging')

  const { data, isLoading, error } = useQuery({
    enabled,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['isInmate'],
    queryFn: async () => {
      await getUser()
      const resp = await axios.get('/service/volunteer/edge/profile/users/facility')
      if (inmateLoggingFlag.isOn && inmateLoggingFlag.config.inmateLogging) {
        splunk.log({
          message: 'useIsInmate:isInmate',
          data: resp.data,
        })
      }
      return resp.data
    },
    staleTime: Number.POSITIVE_INFINITY,
    cacheTime: 1000 * 60 * 60 * 24,
  })

  return {
    isInmate: !!data,
    accessFromCorrectFacility: data?.idxGroupUuid === correctionalFacilityId,
    facility: data,
    isLoading: !enabled ? false : isLoading,
    error,
  }
}
